class YeeseMoments {
  constructor(root) {
    this.root = root;
    this.grid = root.querySelector('[data-moments-grid]');
    this.empty = root.querySelector('[data-moments-empty]');
    this.category = new URL(location.href).searchParams.get('moment') || 'all';
    this.cards = [...root.querySelectorAll('[data-static-card]')];
    this.bindTabs();
    this.bindStoryCards();
    this.bindStoryDialog();
    this.selectTab(this.category, false);
  }

  bindTabs() {
    this.root.querySelectorAll('.ym__tabs [data-category]').forEach((button) => {
      button.addEventListener('click', () => this.selectTab(button.dataset.category, true));
    });
  }

  selectTab(category, updateUrl) {
    const categories = ['all', 'weddings', 'graduation', 'celebrations', 'family', 'confidence'];
    if (!categories.includes(category)) category = 'all';
    this.category = category;
    this.root.querySelectorAll('.ym__tabs [data-category]').forEach((button) => {
      const active = button.dataset.category === category;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
    this.cards.forEach((card) => {
      card.hidden = category !== 'all' && card.dataset.category !== category;
    });
    if (updateUrl) {
      const url = new URL(location.href);
      if (category === 'all') url.searchParams.delete('moment');
      else url.searchParams.set('moment', category);
      history.replaceState({}, '', url);
    }
    this.updateEmpty();
    this.updateFeatured();
  }

  bindStoryDialog() {
    const dialog = this.root.querySelector('[data-story-dialog]');
    this.root.querySelector('[data-story-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  bindStoryCards(scope = this.root) {
    scope.querySelectorAll('[data-card-open]:not([data-bound])').forEach((button) => {
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const dialog = this.root.querySelector('[data-story-dialog]');
        const content = dialog.querySelector('[data-story-content]');
        content.innerHTML = button.innerHTML;
        dialog.showModal();
      });
    });
  }

  updateEmpty() {
    this.empty.hidden = this.grid.querySelectorAll('.ym-card:not([hidden])').length > 0;
  }

  updateFeatured() {
    const wrap = this.root.querySelector('[data-moments-featured]');
    const track = this.root.querySelector('[data-moments-featured-track]');
    const cards = [...this.grid.querySelectorAll('.ym-card:not([hidden])')].slice(0, 8);
    if (!cards.length) {
      wrap.hidden = true;
      return;
    }
    track.innerHTML = '';
    [...cards, ...cards].forEach((card) => track.append(card.cloneNode(true)));
    wrap.hidden = false;
    this.bindStoryCards(track);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-yeese-moments]').forEach((root) => new YeeseMoments(root));
});
